import * as React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { Link, useLocation } from 'react-router-dom';
import LG_Cont from '../containers/Lg_Cont';

const LOGO_URL = "https://pvmodisha.in/wp-content/uploads/2025/06/cropped-cropped-prayash_logo-512-300x300.webp";
const DRAWER_WIDTH = 230;
const GREEN = '#9DDE59';
const BLACK = '#000';
const WHITE = '#fff';

const navItems = [
  // { id: 0, name: 'Registration Form', icon: <AssignmentIcon />, link: '/register' },
  { id: 1, name: 'Admit Card', icon: <AssignmentIcon />, link: '/admitcard' },
];

export default function MiniDrawer(props) {
  const { window: win } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [isClosing, setIsClosing] = React.useState(false);
  const location = useLocation();

  const handleDrawerClose = () => { setIsClosing(true); setMobileOpen(false); };
  const handleDrawerTransitionEnd = () => setIsClosing(false);
  const handleDrawerToggle = () => { if (!isClosing) setMobileOpen(o => !o); };

  const container = win !== undefined ? () => win().document.body : undefined;

  const userName = props.login?.user_details?.name || '';
  const userPic = props.login?.user_details?.profile_pic || '';
  const initials = userName ? userName.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2) : 'U';

  const DrawerContent = () => (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', background: BLACK }}>
      {/* Logo */}
      <Box sx={{ padding: '20px 16px 16px', borderBottom: `1px solid #222`, display: 'flex', alignItems: 'center', gap: '10px' }}>
        <Box sx={{ width: 40, height: 40, borderRadius: '8px', overflow: 'hidden', flexShrink: 0, background: WHITE, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <img src={LOGO_URL} alt="Prayash" style={{ width: '100%', height: '100%', objectFit: 'contain' }} onError={e => { e.target.style.display = 'none'; }} />
        </Box>
        <Box>
          <Typography sx={{ color: GREEN, fontWeight: 800, fontSize: '14px', lineHeight: 1.2 }}>PRAYASH EDUCATION</Typography>
          <Typography sx={{ color: '#777', fontSize: '10px', lineHeight: 1.2 }}>NEET 2027 Portal</Typography>
        </Box>
      </Box>

      {/* User Avatar */}
      <Box sx={{ padding: '20px 16px 12px', textAlign: 'center', borderBottom: '1px solid #222' }}>
        <Box sx={{
          width: 56, height: 56, borderRadius: '50%', background: GREEN,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 auto 10px', overflow: 'hidden',
          border: `3px solid ${GREEN}`, boxShadow: `0 0 0 3px rgba(157,222,89,0.2)`,
        }}>
          {userPic
            ? <img src={userPic} alt="avatar" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            : <Typography sx={{ fontWeight: 700, fontSize: '18px', color: BLACK }}>{initials}</Typography>
          }
        </Box>
        <Typography sx={{ color: WHITE, fontWeight: 600, fontSize: '13px', wordBreak: 'break-word', lineHeight: 1.3 }}>{userName}</Typography>
        <Box sx={{ display: 'inline-block', background: 'rgba(157,222,89,0.15)', border: `1px solid rgba(157,222,89,0.4)`, borderRadius: '12px', padding: '2px 10px', marginTop: '6px' }}>
          <Typography sx={{ color: GREEN, fontSize: '10px', fontWeight: 600, letterSpacing: '0.5px' }}>CANDIDATE</Typography>
        </Box>
      </Box>

      {/* Nav Items */}
      <List sx={{ flex: 1, padding: '12px 8px' }}>
        {navItems.map((item) => {
          const isActive = location.pathname === item.link;
          return (
            <Link key={item.id} to={item.link} style={{ textDecoration: 'none' }}>
              <ListItemButton sx={{
                borderRadius: '8px',
                marginBottom: '4px',
                background: isActive ? GREEN : 'transparent',
                border: isActive ? `1px solid ${GREEN}` : '1px solid transparent',
                '&:hover': { background: isActive ? GREEN : 'rgba(157,222,89,0.1)', border: `1px solid rgba(157,222,89,0.3)` },
                transition: 'all 0.15s',
                padding: '10px 12px',
              }}>
                <ListItemIcon sx={{ color: isActive ? BLACK : '#888', minWidth: 36 }}>
                  {item.icon}
                </ListItemIcon>
                <ListItemText
                  primary={item.name}
                  primaryTypographyProps={{ fontSize: '13px', fontWeight: isActive ? 700 : 500, color: isActive ? BLACK : '#ccc' }}
                />
              </ListItemButton>
            </Link>
          );
        })}
      </List>

      {/* Logout */}
      <Box sx={{ padding: '12px 8px 20px', borderTop: '1px solid #ffffff' }}>
        <LG_Cont />
      </Box>
    </Box>
  );

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />

      {/* AppBar */}
      <MuiAppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${DRAWER_WIDTH}px)` },
          ml: { sm: `${DRAWER_WIDTH}px` },
          background: WHITE,
          boxShadow: '0 1px 8px rgba(0,0,0,0.1)',
          borderBottom: `3px solid ${GREEN}`,
        }}
      >
        <Toolbar sx={{ display: 'flex', justifyContent: 'space-between', padding: '0 20px' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <IconButton
              onClick={handleDrawerToggle}
              sx={{ display: { sm: 'none' }, color: BLACK }}
            >
              <MenuIcon />
            </IconButton>
            <Typography sx={{ color: BLACK, fontWeight: 800, fontSize: '18px', letterSpacing: '0.3px' }}>
              Prayash <span style={{ color: GREEN }}>NEET 2027</span>
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Box sx={{ width: 32, height: 32, borderRadius: '50%', background: GREEN, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
              {userPic
                ? <img src={userPic} alt="avatar" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                : <Typography sx={{ fontWeight: 700, fontSize: '12px', color: BLACK }}>{initials}</Typography>
              }
            </Box>
            <Typography sx={{ color: '#333', fontSize: '13px', fontWeight: 600, display: { xs: 'none', sm: 'block' } }}>{userName}</Typography>
          </Box>
        </Toolbar>
      </MuiAppBar>

      {/* Nav */}
      <Box component="nav" sx={{ width: { sm: DRAWER_WIDTH }, flexShrink: { sm: 0 } }}>
        {/* Mobile drawer */}
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onTransitionEnd={handleDrawerTransitionEnd}
          onClose={handleDrawerClose}
          ModalProps={{ keepMounted: true }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: DRAWER_WIDTH, background: BLACK },
          }}
        >
          <DrawerContent />
        </Drawer>

        {/* Desktop permanent drawer */}
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: DRAWER_WIDTH, background: BLACK, borderRight: '1px solid #222' },
          }}
          open
        >
          <DrawerContent />
        </Drawer>
       
      </Box>
    </Box>
  );
}

MiniDrawer.propTypes = { window: PropTypes.func };
